import ContentsInfo from "./ContentsInfo";
import AltitudeSlider from "./AltitudeSlider";
import { makeStyles } from "@material-ui/core/styles";
import { useRecoilValue } from "recoil";
import { routePointEditingState } from "../../store/RoutePointEditingState";

const useStyles = makeStyles({
  root: {
    position:'absolute',
    display: 'flex',
    left:0,
    bottom: 30,
    height: 218,
    pointerEvents: 'none'
  }
});

function ContentsInfoPanel() {
  const routePointEditing = useRecoilValue(routePointEditingState);
  const classes = useStyles();
  return (
    <div className={classes.root}　hidden={routePointEditing}>
      <ContentsInfo/>
      <AltitudeSlider/>
    </div>
  )
}
export default  ContentsInfoPanel